import React from 'react';
import NavigationContextMenu from '../NavigationContextMenu';
import { faCog, faMoon, faSignOut, faSun } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { UserIcon } from '@/components/Icons';
import { IState } from '@/state/IState';
import { useSelector } from 'react-redux';
import { useIsSeller } from '@/utils/hooks';
import { isProd } from '@/utils/envRenderLogic';
import { useThemePreference } from '@/components/app/ThemePreferenceContext';
interface HeaderUserMenuProps {}

const HeaderUserMenu: React.FC<HeaderUserMenuProps> = (props) => {
    const user = useSelector((state: IState) => state.global.user);
    const isSeller = useIsSeller();
    const { themePreference, setThemePreference } = useThemePreference();

    if (!user) {
        return null;
    }

    const isDark = themePreference === 'dark';

    return (
        <>
            <NavigationContextMenu.Item
                imageElement={<UserIcon userId={user.userId} sizeInPx={36} />}
                title={user.displayName}
                subtitle={user.email}
            />

            <NavigationContextMenu.Separator />

            {isSeller && !isProd && (
                <NavigationContextMenu.Button
                    icon={isDark ? faSun : faMoon}
                    title={isDark ? <Trans>Light mode</Trans> : <Trans>Dark mode</Trans>}
                    onClick={() => setThemePreference(isDark ? 'light' : 'dark')}
                />
            )}

            {!user.readOnly && (
                <NavigationContextMenu.InternalLink to="/user-settings" icon={faCog} title={<Trans>User settings</Trans>} />
            )}

            <NavigationContextMenu.InternalLink to="/logout" icon={faSignOut} title={<Trans>Sign out</Trans>} />
        </>
    );
};

export default HeaderUserMenu;
